<template>
  <div class="footer">
    {{copyright}} <a href="https://beian.miit.gov.cn/" target="_blank">{{ beian }}</a>
  </div>
</template>

<script>
import { getconfig } from '@/api/website'
export default {

  data () {
    return {
      beian: '',
      copyright: ''
    }
  },
  created () {
    this.initConfig()
  },
  methods: {
    initConfig () {
      getconfig().then(res => {
        if (res.code === 0) {
          let arr = res.data
          let copyright = ''
          arr.map(item => {
            if (item.name === 'copyright') {
              copyright = item.value
            }
            if (item.name === 'beian') {
              this.beian = item.value
            }
            if (item.name === 'name') {
              document.title = item.value
            }
          })

          this.copyright = copyright + '  '
        }
      })
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  text-align: center;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 24px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/webfooter.vue